<div class="blue-light ">
  <div class="container">
    <div class="row min-vh-100 py-5 align-items-center justify-content-center">
      <div class="col-auto">
        <div class="login-left">
          <img class="w-75" src="../../assets/images/login-main.jpg" alt="">
          <h1 class="text-center">Let's make data driven business<br>
            safer together.</h1>
          <div class="doubleborder my-5"></div>
          <strong class="text-strong text-gray-500">Trusted by 1000+ Brands Globally</strong>
          <ul class="login-barand-logos mt-2">
            <li><img src="../../assets/images/registration/KFC.png" alt="KFC" title="KFC" /> </li>
            <li><img src="../../assets/images/registration/pizzahut.png" alt="KFC" title="KFC" /> </li>
            <li><img src="../../assets/images/registration/fabindia.png" alt="KFC" title="KFC" /> </li>
            <li><img src="../../assets/images/registration/biba.png" alt="KFC" title="KFC" /> </li>
            <li><img src="../../assets/images/registration/capillary.png" alt="KFC" title="KFC" /> </li>
          </ul>
        </div>
      </div>
      <div class="col-auto pl-5">
        <div class="card login-card">
          <div class="card-body">

            <!-- Forget Password -->
            <div *ngIf="showSetPasswordForm === true">

              <h3 class="mb-2">Create new password</h3>
              <p class="p2 mb-4">Your new password must be different from previous used password</p>
              <form #setForgotPasswordForm="ngForm" class="reset-forgot-password-form">
                <div class="form-group mb-3">
                  <label class="label-03 roboto-regular mb-1">Password</label>
                  <div class="input-group">
                    <input [type]="showPassword ? 'text' : 'password'" class="form-control" type="password" name="password" #password="ngModel" placeholder="Password" [(ngModel)]="userSetPassword.password" [minlength]="6" [maxlength]="19" autocomplete='new-password' required>
                    <div class="input-group-append">
                      <span class="input-group-text" ><i class="fa" [ngClass]="{'fa-eye-slash': !showPassword,'fa-eye': showPassword}" (click)="toggleShowPassword()" ></i></span>
                    </div>
                    <div style="color: red" class="touched-error">
                      <div *ngIf="(password.touched && !password.valid)">
                        password should have a minimum of 6 and maximum of 19 characters
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label class="label-03 roboto-regular mb-1">Confirm Password</label>
                  <div class="input-group">
                    <input [type]="confirmPasswordfield ? 'text' : 'password'" class="form-control" type="password" name="confirmpassword" #confirmpassword="ngModel" placeholder="Confirm password" [(ngModel)]="confirmPassword" [minlength]="6" autocomplete='new-password' [maxlength]="19" required>
                    <div class="input-group-append">
                      <span class="input-group-text" ><i  class="fa" [ngClass]="{'fa-eye-slash': !confirmPasswordfield,'fa-eye': confirmPasswordfield}" (click)="toggleConfirmPassword()"></i></span>
                    </div>
                    <div style="color: red" class="touched-error">
                      <div *ngIf="(confirmpassword.touched && !confirmpassword.valid)">
                        verify password should have a minimum of 6 and maximum of 19 characters
                      </div>
                      <!-- <div *ngIf="!((confirmpassword.touched && !confirmpassword.valid) || (password.touched && !password.valid)) && userSignUpInfo.password !== confirmPassword && confirmpassword.touched && password.touched">
                        password and verify password does not match
                      </div> -->
                    </div>
                  </div>
                </div>
                <div class="mt-4">
                  <button mat-flat-button color="orange" type="submit" class="btn-block btn-lg" [disabled]="disableSetPassword ||  userSetPassword.password!== confirmPassword || !setForgotPasswordForm.valid" mat-raised-button color="orange" (click)="setForgotPasswordFormSubmit()" >Reset Password <span class="button-right-arrow"></span></button>
                </div>



              </form>

            </div>

            <!-- Forget Password end -->
            <!-- success -->
            <div *ngIf="showSetPasswordForm === false">
              <div class="text-center">
                <div class="mb-5">
                  <img src="../../assets/images/new/tick_complete.svg" alt="tick_complete">
                </div>
                <h3 class="mb-2">Congratulations!</h3>
                <p class="p2 mb-4">You have successfully reset you password</p>
                <div class="mt-5 text-center">
                  <span class="label-07">Return to <a  class="HKGroteskBold" routerLink="/login">Login</a></span>
                </div>
              </div>
            </div>
            <!-- success end -->
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

